import { property as h } from "../beacon-property.d/index.js";
import { s as m, B as x } from "./exporting-BTf-uTZb.js";
import { w as d, m as b } from "./lifecycle-decorators-Cg3csm0R.js";
import { i as f } from "./reactive-element-CzWTglSF.js";
import "../beacon-html.d/index.js";
import "./lit-element-sPTOReu4.js";
function y(r, i = " ") {
  if (r)
    return m(r, i);
}
const u = f`.highcharts-axis-title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}.highcharts-axis-labels{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200)}.highcharts-axis-line,.highcharts-grid-line,.highcharts-plot-line.origin-line,.highcharts-tick{stroke-width:var(--beacon-system-width-border-mini)}.highcharts-graph{stroke-width:var(--beacon-system-width-border-normal)}.highcharts-grid-line,.highcharts-axis-line{stroke:var(--beacon-component-data-viz-color-border-minor)}.highcharts-navigator-xaxis .highcharts-grid-line{stroke:var(--beacon-component-data-viz-color-border-minor);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-plot-line.origin-line,.highcharts-tick{stroke:var(--beacon-component-data-viz-color-border-major)}.highcharts-plot-band.negative-area{fill:var(--beacon-system-color-background-1);fill-opacity:1}`;
var v = Object.defineProperty, A = Object.getOwnPropertyDescriptor, n = (r, i, t, a) => {
  for (var e = a > 1 ? void 0 : a ? A(i, t) : i, s = r.length - 1, o; s >= 0; s--)
    (o = r[s]) && (e = (a ? o(i, t, e) : o(e)) || e);
  return a && e && v(i, t, e), e;
};
function B(r) {
  let i = class extends r {
    constructor() {
      super(...arguments), this.yAxisLabel = "", this.xAxisLabel = "";
    }
    static get chartAreaStyles() {
      return u;
    }
    get totalChartCategories() {
      var e, s, o, c, p;
      const t = (s = (e = this.chart) == null ? void 0 : e.series) == null ? void 0 : s.map(
        (l) => {
          var g;
          return (g = l == null ? void 0 : l.data) == null ? void 0 : g.length;
        }
      );
      if (!(t != null && t.length)) return;
      const a = Math.max(...t);
      return (p = (c = (o = this.categories) == null ? void 0 : o.length) != null ? c : a) != null ? p : void 0;
    }
    willUpdate(t) {
      var a;
      (a = super.willUpdate) == null || a.call(this, t), t.has("xAxisLabel") && this.updateChart({ xAxis: { title: { text: this.xAxisLabel } } }), t.has("yAxisLabel") && this.updateChart({ yAxis: { title: { text: this.yAxisLabel } } }), t.has("categories") && this.updateChart({ xAxis: { categories: this.categories } }), t.has("chart") && this._addPlotBands(), t.has("stacking") && this.updateChart({
        plotOptions: { series: { stacking: this.stacking } }
      });
    }
    // Apply the negative area of the chart after we can access the min of the y axis
    _addPlotBands() {
      var t;
      this.updateChart({
        yAxis: {
          plotBands: [
            {
              className: "negative-area",
              from: 0,
              to: (t = this.chart) == null ? void 0 : t.yAxis[0].min
            }
          ]
        }
      });
    }
    get localComponentOptions() {
      return x.createChartOptions(super.localComponentOptions, {
        xAxis: {
          categories: this.categories,
          labels: {
            y: 24
          },
          tickLength: 4,
          title: {
            margin: 16,
            text: this.xAxisLabel
          }
        },
        yAxis: {
          labels: {
            formatter() {
              const { value: t } = this;
              return typeof t == "number" ? t < 1e3 ? `${t}` : t < 1e6 ? `${t / 1e3}k` : `${Math.round(t / 1e4) / 100}M` : t;
            }
          },
          plotLines: [
            // Origin Line
            {
              className: "origin-line",
              value: 0,
              zIndex: 5
              // Layers it over the other grid lines
            }
          ],
          title: {
            margin: 16,
            text: this.yAxisLabel
          }
        }
      });
    }
    getTooltipClasses() {
      var t;
      return `beacon-chart-tooltip ${this.colorOrder} ${this.type} ${((t = this.series) == null ? void 0 : t.length) === 1 ? "single-series-chart" : ""} ${this.stacking ? "stacked-chart" : ""}`.trim();
    }
  };
  return n([
    h({ attribute: "y-axis-label" })
  ], i.prototype, "yAxisLabel", 2), n([
    h({ attribute: "x-axis-label" })
  ], i.prototype, "xAxisLabel", 2), n([
    h({
      converter: (t) => y(t, ",")
    })
  ], i.prototype, "categories", 2), n([
    h({ reflect: !0 })
  ], i.prototype, "stacking", 2), n([
    d("series")
  ], i.prototype, "_addPlotBands", 1), i = n([
    b("ChartArea")
  ], i), i;
}
export {
  B as C
};
